import { APP_NAME } from '@greenroom/shared'
import { clsx } from 'clsx'

/** A doorway with someone waiting in it: the green room before going on. */
export function LogoMark({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 32 32" fill="none" aria-hidden className={clsx('shrink-0', className ?? 'size-7')}>
      <rect width="32" height="32" rx="8" className="fill-accent" />
      <path d="M8 22c0-7 3-12 8-12s8 5 8 12" stroke="white" strokeWidth="3" strokeLinecap="round" />
      <circle cx="16" cy="21" r="2.5" fill="white" />
    </svg>
  )
}

export function Logo({ className }: { className?: string }) {
  return (
    <span className={clsx('inline-flex items-center gap-2.5 font-semibold tracking-tight', className)}>
      <LogoMark />
      <span className="text-[17px]">{APP_NAME}</span>
    </span>
  )
}
